<!-- Dialog title and close button -->
<div class="bottom-shadow dialog-title-padding">
    <div class="page-title">
        <div>
            <h3 class="lato-regular"> User Profile</h3>
        </div>
        <div>
            <mat-icon mat-dialog-close class="cursor">close</mat-icon>
        </div>
    </div>
</div>

<!-- Middle section of the dialog -->
<div class="middle-sec dialog-middle" *ngIf="profile">
    <div fxLayout="row">
        <div fxFlex="30">
            <div class="round"> <img src="https://prod-foodism.s3.ap-south-1.amazonaws.com/{{profile.profile_pic}}"
                    onerror="this.style.display='none';">
                <span *ngIf="!profile.profile_pic">{{ profileImg}}</span>
            </div>
        </div>
        <div fxFlex="70">
            <h3 class="lato-regular margin">{{profile.name}} ({{profile.role.role_name}})</h3>
            <h4 class="lato-regular m-0">{{profile.email}}</h4>
        </div>
    </div>
    <div class="q-pa-lg">
        <hr>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" (click)="openEditDialog(profile)"
        class="cursor">
        <div class="round-icon2"><img src="../../../../assets/images/icons/profile.png"></div>
        <div>
            <p>Edit Profile</p>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" (click)="openPasswordDialog()" class="cursor">
        <div class="round-icon2"><img src="../../../../assets/images/icons/password.png"></div>
        <div>
            <p>Change Password</p>
        </div>
    </div>
</div>
<div class="version">
    <h3 class="lato-regular margin">Version 1.2.0 </h3>
</div>
